module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"demographic_trends":"属性トレンド","Monday":"月曜日","Tuesday":"火曜日","Wednesday":"水曜日","Thursday":"木曜日","Friday":"金曜日","Saturday":"土曜日","Sunday":"日曜日","demographics_trend_expl":"来店したお客様の属性の傾向グラフです。「時間」で平均日の時間ごと、「日」で平均週の曜日ごとの傾向を表示します。","n_of_people":"{0}人"}}')
  delete Component.options._Ctor
}
